import { Suspense, useCallback, useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import Header from "../Header";
import Sidebar from "../Sidebar";
import axios from "axios";
import { Container, Row, Col, Button, OverlayTrigger, Tooltip, Modal} from "react-bootstrap";
import { Overlay, Popover } from "react-bootstrap";
import { useRef } from "react";
import { DatePicker,Input, AutoComplete,List,Typography,Radio,Select,Checkbox} from "antd";
import dayjs from "dayjs";
import moment from "moment";
import { blog, dashboard, doctor, doctorschedule, logout, menuicon04, menuicon06, menuicon08, menuicon09, menuicon10, menuicon11, menuicon12, menuicon14, menuicon15, menuicon16, patients, sidemenu } from '../imagepath';
import Scrollbars from "react-custom-scrollbars-2";
import { use } from 'react';
import FeatherIcon from "feather-icons-react/build/FeatherIcon";

import { Link } from "react-router-dom";
import AddPatientPopup from "./AddPatientPopUp";
import AppointmentModal from "./BookAppointmentPopUp";
import { useAuth } from "../../services/authentication_API/authService";
const { Text } = Typography;
const { Option } = Select;
import { SearchOutlined,DoubleLeftOutlined,DoubleRightOutlined,LeftOutlined, CalendarOutlined,RightOutlined} from "@ant-design/icons";
import { getdoctor, getShifts } from "../../services/doctor/shift schedule/shift_schedule";
import Loader from "../Loader";
import RescheduleAppointment from "./RescheduleAppointment";






const AppointmentBooking = () => {

  const {user, token,userData}=useAuth()
   
  const [selectedSlot, setSelectedSlot] = useState(null);
  const [stats, setStats] = useState([]);
  const [selectedDate, setSelectedDate] = useState(dayjs());
  const [showModal, setShowModal] = useState(false);
  const [selectedSlotDetails, setSelectedSlotDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [step, setStep] = useState("search");
  const [selectedDoctor, setSelectedDoctor] = useState(null);
  const [schedule, setSchedule] = useState(false);
  const today = dayjs().startOf('day'); 


  const modalClose=()=>{
    setShowModal(false)
  }


  const fetchShifts = async () => {
    setLoading(true);
    try {
      const result = await getShifts(selectedDoctor?.id,selectedDate.format("YYYY-MM-DD"));
      if (result.success) {
        console.log("Fetched Data:", result?.data);
        const formData=result?.data;

        setStats(formData);
      } else {
        console.error("Error:", result.error || "Failed to fetch shifts");
      }
    } catch (err) {
      console.error("Exception:", err.message);
    } finally {
      setLoading(false);
    }
  };

  const [showIndex, setShowIndex] = useState(null);
  const targetRefs = useRef([]);

  const formatTime = (minutes) => {
    const hrs = Math.floor(minutes / 60);
    const mins = minutes % 60;
    const period = hrs >= 12 ? "PM" : "AM";
    const displayHours = hrs % 12 === 0 ? 12 : hrs % 12;
    return `${displayHours.toString().padStart(2, "0")}:${mins
      .toString()
      .padStart(2, "0")} ${period}`;
  };

  const getShiftLabel = (startTime) => {
    if (startTime < 360 || startTime >= 1200) return "Night"; // 8 PM to 6 AM
    if (startTime >= 720 && startTime < 1200) return "Evening"; // 12 PM to 8 PM
    return "Morning"; // Before 12 PM
  };
  const isPastSlot = (slotTime) => {
    const today = dayjs().startOf('day');
    const selected = dayjs(selectedDate).startOf('day');
  
    if (selected.isSame(today, 'day')) {
      const currentTimeInMinutes = dayjs().hour() * 60 + dayjs().minute();
      const slotTimeInMinutes =
        dayjs(slotTime, "hh:mm A").hour() * 60 +
        dayjs(slotTime, "hh:mm A").minute();
  
      return slotTimeInMinutes < currentTimeInMinutes;
    }
  
    // If date is not today, we assume it's not a past slot
    return false;
  };
  

//for doctor list
const [doctors, setDoctors] = useState([]);


  const fetchDoctors = async () => {
    try {
      const result = await getdoctor();
      if (result.success) {
        // Transform the hospital data if needed to fit the table structure
        setDoctors(result?.data);
        console.log("Formatted Data:", result.data);
        setSelectedDoctor(result?.data[0]);
      } else {
        console.error("Error:", result.error || "Failed to fetch hospitals");
      }
    } catch (err) {
      console.error("Exception:", err.message);
    } finally {
      setLoading(false);
    }
  };
  console.log("Selected Doctor:", selectedDoctor);

  // Filter the doctors list based on the current filter.

  const handlePrev = () => {
    const today = dayjs().startOf('day'); 
    const previousDate = selectedDate.subtract(1, 'day');
  
    if (previousDate.isBefore(today)) {
      return;
    }
  
    setSelectedDate(previousDate);
  };

  const handleNext = () => {
    setSelectedDate(prev => prev.add(1, 'day'));
  };
  const customFormat = (value) => {
    return dayjs().isSame(value, 'day') ? 'Today, '+value.format('YYYY') : value.format('D MMM YYYY');
  };
  useEffect(() => {
    const initialize = async () => {
      await fetchDoctors();
    };
    initialize();
  }, []);
  
 
  useEffect(() => {
    if (selectedDoctor) {
      fetchShifts();
    }
    else{
      console.log("doctor not selected")
    }
  }, [selectedDate, selectedDoctor,schedule,showModal]);

  const rescheduleAppointment = (appointment) => {
    setSchedule(true);
    setSelectedSlotDetails(appointment);
    console.log("Rescheduling appointment:", appointment);

  }


  return (
    <>
      <Header />
      <Sidebar activeClassName="Reception" />
      <div className="page-wrapper">
        <div className="content">
          {/* Page Header */}
          <div className="page-header">
            <div className="row">
              <div className="col-sm-4 col-6">
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/receptionist-dashboard">Reception </Link>
                  </li>
                  <li className="breadcrumb-item">
                    <i className="feather-chevron-right">
                      <FeatherIcon icon="chevron-right" />
                    </i>
                  </li>
                  <li className="breadcrumb-item active">
                    Appointment Booking
                  </li>
                </ul>
              </div>
              <div className="col-sm-1 text-center ">
                <Link
                  to="#"
                  onClick={() => handlePrev()}
                  className="btn btn-rounded text-center"
                >
                  <DoubleLeftOutlined className="fs-4" />
                </Link>
              </div>
              <div className=" col-6 text-center" style={{ width: "17.5%" }}>
                <DatePicker
                  className="btn  btn-roundedl"
                  value={selectedDate}
                  onChange={(date) => setSelectedDate(date)}
                  format={customFormat}
                  allowClear={false}
                  style={{ width: "auto", background: "white" }}
                  disabledDate={(current) =>
                    current && current < dayjs().startOf("day")
                  }
                />
              </div>
              <div className="col-sm-1 col-6 text-center">
                <Link
                  to="#"
                  onClick={() => handleNext()}
                  className="btn btn-rounded text-center"
                >
                  <DoubleRightOutlined className="fs-4" />
                </Link>
              </div>
            </div>
          </div>
          {/* /Page Header */}
          {loading ? (
            <Loader />
          ) : (
            <div className="row">
              <div className="card card-table show-entire">
                <div className="card-body p-0">
                  <div className="row g-0">
                    {/* Doctor Selection Sidebar */}
                    {doctors.length > 1 && (
                      <div
                        className="col-md-3 col-lg-3 border-end"
                        style={{
                          position: "sticky",
                          top: "0", // adjust as needed
                          height: "100vh", // optional if you want it to stick fully on scroll
                          zIndex: 1, // optional, for layering
                          backgroundColor: "#fff", // to avoid transparency issues
                        }}
                      >
                        <div className="p-3">
                          <div className="d-flex justify-content-between mb-3">
                            <button
                              className={`btn btn-link text-decoration-none ${"fw-bold"}`}
                              // onClick={() => setFilter("allDoctors")}
                              style={{ color: "#2e37a4" }}
                            >
                              All Doctors
                            </button>
                          </div>

                          <div className="list-group">
                            {doctors.map((doctor) => (
                              <button
                                key={doctor.id}
                                onClick={() => setSelectedDoctor(doctor)}
                                className={`list-group-item list-group-item-action mb-2 ${
                                  selectedDoctor &&
                                  selectedDoctor.id === doctor.id
                                    ? "active bg-light fw-bold"
                                    : ""
                                }`}
                                style={{
                                  border: "none", // Remove all borders
                                  borderLeft:
                                    selectedDoctor &&
                                    selectedDoctor.id === doctor.id
                                      ? "4px solid #2e37a4"
                                      : "4px solid transparent",
                                  color:
                                    selectedDoctor &&
                                    selectedDoctor.id === doctor.id
                                      ? "#2e37a4"
                                      : "",
                                  borderRadius: "0.5rem", // keep rounded look if needed
                                }}
                              >
                                <div className="w-100">
                                  <h5 className="mb-1">{doctor.name}</h5>
                                  <p className="mb-0 small">
                                    {doctor.hospital.name}
                                  </p>
                                  <small className="text-muted">
                                    {doctor.location}
                                  </small>
                                </div>
                              </button>
                            ))}
                          </div>
                        </div>
                      </div>
                    )}

                    {/* Appointment Slots */}
                    {loading ? (
                      <Loader />
                    ) : (
                      <div
                        className={
                          doctors.length === 1
                            ? "col-md-12 col-lg-12"
                            : "col-md-9 col-lg-9"
                        }
                        style={{
                          height: "80vh", // full screen height
                          overflowY: "auto",
                        }}
                      >
                        {/* Slots Section */}
                        <div className="p-4">
                          {stats.length > 0 ? (
                            <>
                              {stats?.map((shift, shiftIndex) => (
                                <div key={shiftIndex} className="mb-4">
                                  <div className="d-flex align-items-center mb-3">
                                    <h5 className="mb-0 me-3">
                                      {shift.name} ({shift.start_time} to{" "}
                                      {shift.end_time})
                                    </h5>
                                    <a
                                      href="#"
                                      style={{ color: "#2e37a4" }}
                                      onClick={(e) => {
                                        e.preventDefault();
                                        setShowModal(true);
                                        setStep("add extra slot");
                                      }}
                                    >
                                      Add extra slots
                                    </a>
                                  </div>

                                  <Row className="g-2 justify-content-start">
                                    {shift.time_slots.map((slot, index) => (
                                      <Col
                                        key={index}
                                        xs="auto"
                                        className="mb-2"
                                      >
                                        <div
                                          ref={(el) =>
                                            (targetRefs.current[
                                              `${shiftIndex}-${index}`
                                            ] = el)
                                          }
                                          onClick={() =>
                                            setShowIndex(
                                              `${shiftIndex}-${index}`
                                            )
                                          }
                                          onMouseLeave={() =>
                                            setShowIndex(null)
                                          }
                                          onMouseEnter={() =>
                                            setShowIndex(
                                              `${shiftIndex}-${index}`
                                            )
                                          }
                                        >
                                          <Button
                                            variant={
                                              slot?.booked ? "success" : "light"
                                            }
                                            className={`rounded-3 position-relative ${
                                              selectedSlot === slot.slot_number
                                                ? "border-primary"
                                                : ""
                                            }`}
                                            style={{
                                              width: "120px", // ✅ fixed button width
                                              height: "40px", // ✅ fixed button height
                                              opacity: isPastSlot(
                                                slot.slot_start_time
                                              )
                                                ? 0.6
                                                : 1,
                                              cursor: isPastSlot(
                                                slot.slot_start_time
                                              )
                                                ? "not-allowed"
                                                : "pointer",
                                              backgroundColor: slot?.booked
                                                ? "#bef7a1"
                                                : isPastSlot(
                                                    slot.slot_start_time
                                                  )
                                                ? "lightgrey"
                                                : "white",
                                              border: slot?.booked
                                                ? "1px solid #1890ff"
                                                : "1px solid #d9d9d9",
                                              boxShadow: isPastSlot(
                                                slot.slot_start_time
                                              )
                                                ? "none"
                                                : "0 2px 4px rgba(0, 0, 0, 0.1)",
                                            }}
                                            onClick={() => {
                                              if (
                                                !isPastSlot(
                                                  slot.slot_start_time
                                                )
                                              ) {
                                                setSelectedSlot(
                                                  slot.slot_number
                                                );
                                                setSelectedSlotDetails({
                                                  ...slot,
                                                  shift_id: shift?.id,
                                                });
                                                setStep("search");
                                                setShowModal(true);
                                              }
                                            }}
                                            disabled={
                                              isPastSlot(
                                                slot.slot_start_time
                                              ) || slot?.booked
                                            }
                                          >
                                            <div className="d-flex align-items-center justify-content-center">
                                              <div
                                                className="rounded-circle me-1"
                                                style={{
                                                  width: "13px",
                                                  height: "13px",
                                                  border: "1px solid #000000",
                                                }}
                                              ></div>
                                              <span
                                                style={{
                                                  marginLeft: "8px",
                                                  fontSize: "12px",
                                                  color: "#555",
                                                }}
                                              >
                                                ({slot?.slot_start_time})
                                              </span>
                                            </div>
                                          </Button>

                                          {slot.booked && (
                                            <Overlay
                                              target={
                                                targetRefs.current[
                                                  `${shiftIndex}-${index}`
                                                ]
                                              }
                                              show={
                                                showIndex ===
                                                `${shiftIndex}-${index}`
                                              }
                                              placement="top"
                                            >
                                              <Popover>
                                                <Popover.Header
                                                  as="h5"
                                                  className="bg-white border-bottom"
                                                >
                                                  <div className="d-flex align-items-center">
                                                    <div
                                                      className="rounded-circle me-2"
                                                      style={{
                                                        width: "30px",
                                                        height: "30px",
                                                        backgroundColor:
                                                          "#f0f0f0",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent:
                                                          "center",
                                                      }}
                                                    >
                                                      👤
                                                    </div>
                                                    {
                                                      slot.appointment.patient
                                                        .first_name
                                                    }{" "}
                                                    {
                                                      slot.appointment.patient
                                                        .last_name
                                                    }
                                                  </div>
                                                </Popover.Header>
                                                <Popover.Body>
                                                  <div className="mb-2">
                                                    <div className="d-flex mb-1">
                                                      <span className="me-2">
                                                        📞
                                                      </span>
                                                      <span>
                                                        {
                                                          slot.appointment
                                                            .patient.mobile
                                                        }
                                                      </span>
                                                    </div>
                                                    <div className="d-flex mb-1">
                                                      <span className="me-2">
                                                        ⏰
                                                      </span>
                                                      <span>
                                                        {
                                                          slot?.appointment
                                                            ?.appointment_time
                                                        }
                                                      </span>
                                                    </div>
                                                    <div className="d-flex mb-1">
                                                      <span className="me-2">
                                                        📋
                                                      </span>
                                                      <span>
                                                        {
                                                          slot?.appointment
                                                            ?.reason_for_appointment
                                                        }
                                                      </span>
                                                    </div>
                                                  </div>
                                                  {!isPastSlot(
                                                    slot.slot_start_time
                                                  ) && (
                                                    <div className="d-flex justify-content-between mt-3">
                                                      <Button
                                                        variant="outline-primary"
                                                        size="sm"
                                                        className="w-100 me-1"
                                                        onClick={() => {
                                                          rescheduleAppointment(
                                                            slot?.appointment
                                                          );
                                                        }}
                                                      >
                                                        Reschedule
                                                      </Button>
                                                      <Button
                                                        variant="outline-danger"
                                                        size="sm"
                                                        className="w-100 ms-1"
                                                      >
                                                        Cancel
                                                      </Button>
                                                    </div>
                                                  )}
                                                </Popover.Body>
                                              </Popover>
                                            </Overlay>
                                          )}
                                        </div>
                                      </Col>
                                    ))}
                                  </Row>
                                </div>
                              ))}
                            </>
                          ) : (
                            <div className="flex items-center justify-center h-screen">
                              <div className="text-center">
                                Create a shift to see available slots
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}

          {showModal && (
            <AppointmentModal
              showModal={showModal}
              setShowModal={setShowModal}
              doctor={selectedDoctor}
              selectedSlot={selectedSlotDetails}
              selectedDate={selectedDate}
              step={step}
              setStep={setStep}
               booking_type={"slot"}
            />
          )}
          {schedule && (
            <RescheduleAppointment
              visible={schedule}
              onCancel={setSchedule}
              doctors={selectedDoctor}
              appointment={selectedSlotDetails}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default AppointmentBooking;
